import * as React from "react";
const IconFisLow = () => (
  // <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" className="icon" viewBox="0 0 20 20">
  //   <path d="M15.89 14.696l-4.734-4.734 4.717-4.717c.4-.4.37-1.085-.03-1.485s-1.085-.43-1.485-.03L9.641 8.447 4.97 3.776c-.4-.4-1.085-.37-1.485.03s-.43 1.085-.03 1.485l4.671 4.671-4.688 4.688c-.4.4-.37 1.085.03 1.485s1.085.43 1.485.03l4.688-4.687 4.734 4.734c.4.4 1.085.37 1.485-.03s.43-1.085.03-1.485z" />
  // </svg>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" id="FISLimited">
    <circle
      cx="7"
      cy="7"
      r="7"
      fill="#7A756F"
      // style="fill:#7A756F;fill:color(display-p3 0.4784 0.4588 0.4353);fill-opacity:1;"
    ></circle>
    <path
      d="M3 7H11"
      stroke="white"
      // style="stroke:white;stroke-opacity:1;"
      strokeLinecap="round"
    ></path>
  </svg>
);
export default IconFisLow;
